import { IIntervalService } from 'angular';
import { SystemTypeCollection } from 'app/shared/collections/system_type_collection.service';
import { CensoredSystemResource } from 'app/shared/resources';
import { CensoredSystem } from './censored_system';
import { SiteStateService } from 'app/shared/site_state.service';
import ImsObjectCollection, {
    ImsObjectCollectionOptions,
} from 'app/shared/collections/ims_object_collection.service';
import constants from 'app/shared/utilities/constant';
import { StartupRegistry } from 'app/startup/registry/registry';
import { ILocalStorageService } from 'angular-local-storage';

export class CensoredSystemCollection extends ImsObjectCollection<CensoredSystem> {
    constructor(
        startUpRegistry: StartupRegistry,
        localStorageService: ILocalStorageService,
        $interval: IIntervalService,
        private siteStateService: SiteStateService,
        systemTypeCollection: SystemTypeCollection,
    ) {
        super(
            startUpRegistry,
            localStorageService,
            $interval,
            CensoredSystemResource,
            CensoredSystem,
            {
                refreshRate: 600000,
                incremental: true,
                onDemand: false,
            } as ImsObjectCollectionOptions,
        );

        this.defineRelationship('type', null, 'type_id', systemTypeCollection);

        this.siteStateService.onSiteSelectionChanged(this.refreshDataCallback.bind(this));
    }

    private refreshDataCallback() {
        if (this.isRunning()) {
            // Reset the initialization state of incremental collections when the site changes.
            // This will make all zyxAsync calls on the collection wait for the first
            // update of data from the API
            // this.collectionNotInitialized = true;
            if (!this.onDemand) {
                this.resetCollection();
                this.refreshData();
            }
        }
    }

    resetCollection() {
        this.lastUpdatedFromApi = new Date(0);
        this.refreshCount = 0;
        super.resetCollection();
    }

    _filterInternal(systemsMap: SystemsMap): SystemsMap {
        const currSiteId = this.siteStateService.selectedSiteId;

        Object.keys(systemsMap).forEach((id) => {
            const system = systemsMap[id];
            //System can be enabled for all sites (blank site_ids list) or enabled for specific sites
            if (system.site_ids?.length > 0 && !system.site_ids.includes(currSiteId)) {
                delete systemsMap[id];
            }
        });

        return systemsMap;
    }

    refreshData(params = {}, checkTime = false, useInFlightCheck = false) {
        // If there's no site yet, just return and wait for the site changed event.
        // if (!this.siteStateService.selectedSiteId) {
        //     return Promise.resolve();
        // }

        return super.refreshData(params, checkTime, useInFlightCheck);
    }

    /**
     * Handy helper for retrieving the system name. The default, no systemId is given, will be a
     * constant value.
     * @param systemId
     */
    getOrDefaultCensoredSystemName(systemId: number | undefined): string {
        if (systemId !== null) {
            const system = this.get(systemId);
            if (system) {
                return system.name;
            }
        }

        return constants.CensoredSystemTypeDefault;
    }
}

interface SystemsMap {
    [id: string]: CensoredSystem;
}
